import { render } from "./EntryPage.vue?vue&type=template&id=dc9bf036&scoped=true&ts=true"
import script from "./EntryPage.vue?vue&type=script&lang=ts"
export * from "./EntryPage.vue?vue&type=script&lang=ts"

import "./EntryPage.vue?vue&type=style&index=0&id=dc9bf036&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc9bf036"]])

export default __exports__